<template>
  <div v-if="item.note" class="cart-item__note-container" :class="{'editing' : isEditing}">
    <!-- User has not created a note yet. Hide this link when user is inputting/editing a note -->
    <a v-show="noteIsBlankAndUserIsNotEditing" @click.prevent="toggleEditItemNote()" href="#" class="cart-item__note-action">
      <span class="fa fa-edit"></span>Add note
    </a>

    <!-- User has a note, but is not editing -->
    <div v-show="userHasNoteAndIsNotEditing" class="cart-item__note-row">
      <a @click.prevent="toggleEditItemNote()" href="#" v-show="item.note" class="cart-item__note-text">
        {{item.note.note}}
      </a> &nbsp;
      <a @click.prevent="toggleEditItemNote()" href="#" class="cart-item__note-action"><span class="fa fa-edit"></span> Edit</a>
    </div>

    <form v-show="isEditing" @submit.prevent="saveNote()" class="cart-item__note-form">
      <input type="text" @blur="saveNote" v-model="item.note.note" maxlength="255" class="cart-item__note-input form-control" v-on:keyup.esc="toggleEditItemNote()" ref="noteInput"  v-on:input="sanitizeItemNoteInput">
      <span class="fa fa-times-circle cart-item__delete-note" title="Remove Note" @mousedown.prevent="deleteNote" ></span>
    </form>

  </div>
</template>

<script>
export default {
  name: 'CartItemNote',
  props: {
    cartItem: {
      type: Object
    },
    cartItemIndex: {
      type: Number
    },
    bucket: {
      type: String,
      default: 'cart' // cart, orderAddOns. Used for figuring out how many items are in a specific bucket
    }
  },
  data () {
    return {
      isEditing: false,
      item: JSON.parse(JSON.stringify(this.cartItem))
    }
  },
  computed: {
    noteIsBlankAndUserIsNotEditing: function () {
      return (
        (this.item.note.note === '' && !this.isEditing) ||
        !this.item.note.note.length > 1
      )
    },
    userHasNoteAndIsNotEditing: function () {
      return this.item.note.note.length > 0 && this.isEditing === false
    }
  },
  methods: {
    toggleEditItemNote: function () {
        this.isEditing = !this.isEditing
        this.$nextTick(() => this.$refs.noteInput.focus())
    },
    saveNote: function () {
      var vm = this;
      vm.sanitizeItemNoteInput()
      vm.$store.dispatch(this.bucket + '/PUT_ITEM_NOTE', vm.item)
      this.isEditing = false
    },
    deleteNote: function () {
      this.item.note.note = ''
    },
    cancelWithoutSaving (e) {
      // Reset note back to original if user cancels without saving
      // @todo figure out why the modal keeps reopening when using the esc key after editing a note
      if (e.trigger != 'saved' && this.$data) {
        this.item.note.note = this.cartItem.itemNote
      }
    },
    sanitizeItemNoteInput() {
      //Remove non-ASCII characters from the item note.
      this.item.note.note = this.item.note.note.replace(/[^\x00-\x7F]/g, "");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/lib";

.cart-item__note-container {
  font-size: 14px;
  padding-bottom: 8px;
  margin-right: 8px;
  width: 100%;
  overflow: hidden;

  &:not(:first-child) {
    margin-left: 16px;
  }

  &.editing{
    flex-basis: 100%;
    margin-left: 0;
  }
}

.cart-item__note-action {
  color: #7a7a7a;
  font-weight: 600;
  white-space: nowrap;
}

.cart-item__note-row {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.cart-item__note-form {
  position: relative;
  display: flex;
  align-items: center;
}

.cart-item__note-form-mobile {
  width: 100%;
  position: relative;
}

.cart-item__add-note {
  cursor: pointer;
}

.cart-item__note-text {
  max-width: 400px;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  color: $color-text-standard;
  cursor: pointer;
  font-style: italic;
  white-space: nowrap;
  margin-right: 4px;
}

.cart-item__note-input {
  box-sizing: border-box;
  height: 38px;
  width: 100%;
  padding: 6px 12px;
  padding-right: 32px;
  font-size: 14px;
  line-height: 1.5;
}

.cart-item__note-input-mobile {
  width: 100%;
  margin-bottom: 16px;
}

.cart-item__delete-note {
  color: #ccc;
  position: absolute;
  right: 1rem;
  top: 12px;
  cursor: pointer;
  font-size: 18px;
}

@media screen and (min-width: 992px) {
  .cart-item__note-container {
    flex-grow: 1;
    flex-basis: 90px;
    flex-shrink: 0;
  }

  .cart-item__delete {
    margin-right: 16px;
  }

  .cart-item__note-action {
    padding: 0.5rem 0;
    display: inline-block;
  }
}
</style>

<docs>
How to use:

Pass in `CartItemNote` as a prop. `CartItemNote` should be an array of commerceItems

</docs>
